import styled from "styled-components";

export const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  overflow: hidden;
`;

export const ContentContainer = styled.div`
  flex: 1;
  overflow: hidden;
  position: relative;
`;
